export const ACTIONS = {
    JOIN : "join",
    JOINED : "joined",
    DISCONNECTED: 'disconnected',
    CODE_CHANGE: "code-change",
    SYNC_CODE : 'sync-code',
    LEAVE: 'leave'
}